import { Outlet } from "react-router-dom"

export default function BrandMedia() {
  return (
    <div className="h-full px-4 py-2 bg-basic-black text-basic-light">
      <Outlet />
    </div>
  )
}
